exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uppercase[data-v-ff72dbd6]{text-transform:uppercase}a[data-v-ff72dbd6]{color:#00e;text-decoration:underline}.description[data-v-ff72dbd6]{font-size:.85em;margin:0 0 3px;padding:0}", ""]);

// exports
